import { useQueryClient } from '@tanstack/react-query';
import { useSite } from '../../../../context/page-context';
import { useOptimisticMutation, type Variables } from '../../../../hooks/use-optimistic-mutation';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { TeamApiResponse, TeamInviteApiResponse } from '../../types';
import { QK_ACCOUNT_TEAM } from './use-account-team';

export function useInviteTeamMember() {
  const queryClient = useQueryClient();
  const { accountApi } = useAccountApi();
  const { teamId } = useSite();

  async function invite(payload: Omit<TeamInviteApiResponse, 'id'>) {
    await accountApi.team(teamId).invite(payload);
  }

  return useOptimisticMutation<
    TeamApiResponse, // Response
    Variables<typeof invite>
  >({
    queryClient,
    queryKey: QK_ACCOUNT_TEAM(teamId),
    mutationFn: invite,
    optimisticUpdate: (prev, payload) => {
      if (!prev) {
        return prev;
      }

      const optimisticInvite: TeamInviteApiResponse = {
        id: -Date.now(), // NOTE: the real id is assigned on the backend, onSettled's invalidate replaces this
        email: payload.email,
        role: payload.role,
      };

      return { ...prev, invites: [...prev.invites, optimisticInvite] };
    },
  });
}
